// extracted by mini-css-extract-plugin
export default {"loadingImage":"LoadingIndicator_loadingImage__DUJx8","rotation":"LoadingIndicator_rotation__TqMNh"};